import RichText from "@/components/RichText";
import { openCookiePreferences, useCookieBannerEnabled } from "@/lib/consent";
import { SmartLink } from "../components/Primitives";
import { BTN_OUTLINE, CONTAINER, EYEBROW_LIGHT } from "../tokens";

// Politique de confidentialité (/confidentialite) du moteur "couture_v1" —
// même gabarit que les mentions légales (LegalContentSection.jsx) : colonne
// unique de 820px, sur-titre, H1 Cormorant, filet, une section par bloc
// "privacy_block" (H2 23px + corps 14px/1.85), boutons de gestion des
// cookies et de retour. Le contenu vient du Studio (page « Politique de
// confidentialité »), voir backend/services/theme_engines/shared_pages.py.
export default function PrivacyContentSection({ props = {}, blocks = [] }) {
  const items = (blocks || []).filter((b) => b.type === "privacy_block" && b.enabled !== false);
  const bannerEnabled = useCookieBannerEnabled();

  return (
    <section>
      <div className={`${CONTAINER} px-5 md:px-11`} style={{ paddingTop: "clamp(48px,6vw,80px)", paddingBottom: "clamp(48px,6vw,80px)" }}>
      <div className="max-w-[820px]">
        <RichText as="div" className={EYEBROW_LIGHT} html={props.privacy_eyebrow} />
        <RichText
          as="h1"
          className="block font-display font-light text-[clamp(30px,4vw,46px)] leading-[1.12] text-ink mt-[18px]"
          html={props.privacy_heading}
        />
        <span className="block w-16 h-px bg-ink/25 mt-[30px] mb-10" aria-hidden="true" />

        {props.privacy_intro && (
          <RichText
            as="div"
            preserveParagraphs
            className="text-[15px] leading-[1.85] font-light text-graphite [text-wrap:pretty] mb-10 [&_p]:mb-3.5 [&_p:last-child]:mb-0 [&_a]:underline [&_a]:underline-offset-2 [&_a:hover]:text-ash"
            html={props.privacy_intro}
          />
        )}

        <div className="grid gap-[34px]">
          {items.map((b) => (
            <div key={b.id} data-block-key={b.id}>
              <RichText
                as="h2"
                className="block font-display font-normal text-[23px] leading-[1.25] text-ink mb-3"
                html={b.props?.title}
              />
              <RichText
                as="div"
                preserveParagraphs
                className="text-[14px] leading-[1.85] font-light text-graphite [text-wrap:pretty] [&_p]:mb-3.5 [&_p:last-child]:mb-0 [&_a]:underline [&_a]:underline-offset-2 [&_a:hover]:text-ash"
                html={b.props?.body}
              />
            </div>
          ))}
        </div>

        <div className="flex flex-wrap gap-3 mt-11">
          {bannerEnabled && props.privacy_cookie_button_label && (
            <button type="button" onClick={openCookiePreferences} className={BTN_OUTLINE} data-testid="privacy-cookie-prefs">
              {props.privacy_cookie_button_label}
            </button>
          )}
          {props.privacy_back_label && (
            <SmartLink url={props.privacy_back_url || "/"} className={BTN_OUTLINE}>
              {props.privacy_back_label}
            </SmartLink>
          )}
        </div>
      </div>
      </div>
    </section>
  );
}
